import { createSelector } from 'reselect';

const optionsSidebarSelector = state => state.optionsSidebar;

export const isOptionsSidebarVisibleSelector = createSelector([optionsSidebarSelector], optionsSidebar => optionsSidebar.isVisible);
